export enum LoiFormsProcessStep {
    BuyerSubmission = 0,
    AdminReview = 1,
    BuyerReview = 2,
}

export enum LoiFormsProcessStepStatus {
    InProgress = 0,
    Completed = 1,
    Superseded = 2,
}

export interface LoiFormsProcess {
    id: number;
    buyerId: number;
    loiFormId: string;
    step: LoiFormsProcessStep;
    stepStatus: LoiFormsProcessStepStatus;
    dateCreated: string;
    completedAt: string | null;
    documentDetailsId: string | null;
    documentName: string | null;
}

export const isLoiProcessCompleted = (p: LoiFormsProcess): boolean =>
    p.step === LoiFormsProcessStep.BuyerReview && p.stepStatus === LoiFormsProcessStepStatus.Completed;

export const isLoiProcessSuperseded = (p: LoiFormsProcess): boolean =>
    p.stepStatus === LoiFormsProcessStepStatus.Superseded;

export const getActiveLoiProcess = (processes: LoiFormsProcess[]): LoiFormsProcess | null =>
    processes.find(p => !isLoiProcessCompleted(p) && !isLoiProcessSuperseded(p)) ?? null;

export const isLoiResubmissionFlow = (processes: LoiFormsProcess[]): boolean =>
    getActiveLoiProcess(processes) != null &&
    processes.some(p => isLoiProcessCompleted(p) || isLoiProcessSuperseded(p));

export const getLastCompletedLoiProcess = (processes: LoiFormsProcess[]): LoiFormsProcess | null =>
    [...processes]
        .filter(isLoiProcessCompleted)
        .sort((a, b) => (b.completedAt ?? '').localeCompare(a.completedAt ?? ''))[0] ?? null;
